import type { PayloadAction, Draft, WritableDraft } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import { MenuItem } from "consts/shipmentTracking";
import type { ThunkReturnType } from "types";
import type {
    ShipmentTrackingState,
    TransactionTrackingDeliveryCodesResponse
} from "./types";

export const shipmentTrackingResourceRequestLoading = (menuItem: MenuItem) =>
    (state: WritableDraft<ShipmentTrackingState>) => {
        state[menuItem].tableLoadingState = ApiState.Pending;
    };

export const shipmentTrackingResourceRequestRejected = (menuItem: MenuItem) =>
    (state: WritableDraft<ShipmentTrackingState>) => {
        state[menuItem].tableLoadingState = ApiState.Failed;
    };

export const exportShipmentTrackingResourceLoading = (menuItem: MenuItem) => (
    state: WritableDraft<ShipmentTrackingState>,
    { payload }: PayloadAction<Draft<ApiState>>
) => {
    state[menuItem].exportLoadingState = payload;
};

export const transactionTrackingDeliveryCodesRequestFulfilled = (
    state: WritableDraft<ShipmentTrackingState>,
    { payload }: PayloadAction<ThunkReturnType<TransactionTrackingDeliveryCodesResponse>>
) => {
    state[MenuItem.TransactionTrackingDeliveryCodes].tableLoadingState = ApiState.Succeeded;
    state[MenuItem.TransactionTrackingDeliveryCodes].tableSlice = payload!.data;
};
